<template>

  <div id="app">
    <div v-if="wrap" class="wrap" style="overflow:auto;background: #FAFAFA;">
      <nav-bar></nav-bar>
       <banner></banner>
       <info></info>
       <!-- 分割线 -->
       <div class="dividing-line">
         <div class="line"></div>
         <div class="icon"></div>
         <div class="lable">我们的联系方式</div>
         <div class="icon"></div>
         <div class="line"></div>
       </div>
<!-- 联系方式 -->
       <div class="lianxi-fangshi">
          <div class="row">
            <div class="row-col"><span class="i"> 
               <img src ="./assets/wrap-img/c1.svg" />
              </span> <span class="lable">13568891606</span></div>
            <div class="row-col"><span class="i">
               <img src ="./assets/wrap-img/c2.svg" />
               </span><span class="lable" >1664386@qq.com</span></div>
          </div>
          <div class="row"> <div class="row-col"><span class="i"> 
             <img src ="./assets/wrap-img/c3.svg" />
             </span><span class="lable" >www.haoyuicreate.com</span></div></div>
          <div class="row" > <div class="row-col"><span class="i">
             <img src ="./assets/wrap-img/c4.svg" /> </span><span class="lable">成都市高新区盛治街777号朗诗熙华府20栋805号</span></div></div>
       </div>
       <!-- 版权 -->
       <div class="banquan">
      
      <div class="text"> Copyright © 2021 成都昊雨科技有限公司 </div>
      <div class="text" style=""><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蜀ICP备2020034729号</a></div>
     </div>
    </div>
    <div v-if="!wrap">
    <!-- 顶部导航 -->
    <div class="top" >
      <div class="top-content">
        <div class="logo"><img src ="./assets/img/logo.svg" style="vertical-align: middle;" /></div>
        <div class="nav">
          <div 
          :class="['nav-item',{'active':item.active}]" 
          v-for="(item,index) in nav" 
          :key="index"
          >{{item.text}}</div>
        </div>
        <div class="button"  @click="dialogVisible = true">联系我们</div>
      </div>
  </div>
  <!-- banner -->
   <div class="banner">
     <div class="banner_img">
        <img src ="./assets/img/banner.png" />
     </div>
     <div class="banner_lable">
       <div>昊雨科技，助您智造未来！</div>
       <div>Haoyu Technology</div>
     </div>
   </div>
   <!-- 内容 -->
    <div class="content-container">
      <div class="content">
        <div class="item-list">
          <div class="item" v-for="(item,index) in shuoming" :key="index">
            <i>  <img :src ="item.url"></i>
            <span class="title">{{item.title}}</span>
            <span class="text">{{item.text}}</span>
          </div>
         
        </div>

      </div>
    </div>
    <!-- 版权 -->
     <div class="footer">
       Copyright © 2021 成都昊雨科技有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蜀ICP备2020034729号</a>
     </div>
     <!-- 弹窗 -->
     <el-dialog
      title="联系我们"
      :visible.sync="dialogVisible"
      width="421px"
    >
      <div class="dialog-content">
        <div class="row">
          <div class="row-col"><i class="c1"> </i> <span >13568891606</span></div>
          <div class="row-col"><i class="c3"> </i><span >1664386@qq.com</span></div>
        </div>
        <div class="row"> <div class="row-col"><i class="c2"> </i><span >www.haoyuicreate.com</span></div></div>
        <div class="row" > <div class="row-col"><i class="c4"> </i><span >成都市高新区盛治街777号朗诗熙华府20栋805号</span></div></div>
      </div>
    
    <span slot="footer" class="dialog-footer">
      <span class="button"  @click="dialogVisible = false">我知道了</span>
    </span>
  </el-dialog>
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar'
import Banner from './components/Banner'
import Info from './components/Info'

export default {
  name: 'App',
  components:{NavBar,Banner,Info},

  data(){
    return {
       wrap:false,
      shebeiInfo:null,
      // wrap:this._isMobile(),
      dialogVisible:false,
      shuoming:[
        {
          url:require('./assets/img/i1.png'),
          title:'公司简介',
          text:'成都昊雨科技有限公司成立于2014年，依循 ISO9000质量管理体系，专注于企业智能化标准体系管理软件的研发，为企业提供定制化软件服务，以及信息系统集成服务。'
        },
        {
          url:require('./assets/img/i2.png'),
          title:' 质量管理',
          text:'昊雨科技与国内知名标准体系认证中心拥有多年合作关系，致力于对ISO9000质量管理体系的钻研，将标准体系的理念贯彻于软件产品中，助力各行业轻松实现智能化质量管理。'
        },
        {
          url:require('./assets/img/i3.png'),
          title:'定制服务（管理+软件）',
          text:'昊雨科技为国内多家机械加工、电子以及工程行业提供定制化管理软件服务。依循ISO9000标准要求，为企业进行管理流程再造，根据企业特定需求，为其量身定制软件服务，助其实现智能化质量管理。'
        }
      ],
      nav:[
        {text:'首页',active:true}
      ],
    }
  },
  created(){
    console.log(this._isMobile(),'设备')
  },
  mounted() {
    const that = this
    window.onresize = () => {
        // return (() => {
            window.screenWidth = document.body.clientWidth
             console.log(window.screenWidth,'变化')
            that.screenWidth = window.screenWidth
            if(this._isMobile() || screenWidth<=750){
            that.wrap = true
          }else{
            that.wrap = false
          }
        // })()
    }
 
},
watch:{
  screenWidth:{
    immediate:true,
    handler:function(newValue,oldValue){
        console.log('屏幕变化')
         this.$nextTick(()=> {
          let screenWidth = document.body.clientWidth
          if(this._isMobile() || screenWidth<=750){
            this.wrap = true
          }else{
            this.wrap = false
          }
        })
    }
   
  },
  Window:{
    immediate:true,
    deep:true,
    handler:function(newValue,oldValue){
        console.log('屏幕变化1')
         this.$nextTick(()=> {
          let screenWidth = document.body.clientWidth
          if(this._isMobile() || screenWidth<=750){
            this.wrap = true
          }else{
            this.wrap = false
          }
        })
    }
  }
},
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(flag){
        return true
      }else{
        return false
      }
    }
  }
}
</script>

<style  lang = "scss">
@import 'assets/css/pc/index.scss';
@import 'assets/css/style.scss';
@import 'assets/css/function.scss';
/* 分割线 */
.dividing-line{
 
  display: flex;
  /* border:1px solid red; */
  margin:h(40) w(24) h(31) w(24);
  div{
    /* border:1px solid red; */
    height:h(26);
    line-height: h(26);
    
    /* flex:1; */
    &.line{
      /* width:w(200); */
      height:h(1);
      background:#D8D8D8;
      /* flex:content; */
      flex:1;
      margin-top:h(13);
      /* margin-top: 50%; */
    }
    &.icon{
      width:w(10);
      height:h(10);
      border-radius: 50%;
      background: #D8D8D8;
      margin-top:h(8);
      flex:content;
    }
    &.lable{
      margin:0 w(11);
      font-size:f(26);
      width:w(214);
      flex:content;
      /* border:1px solid red; */
      text-align: center;
      /* white-space: nowrap; */
    }

  }
}
/* 联系方式 */
.lianxi-fangshi{
  /* border:1px solid red; */
  margin:0 w(24) h(109) w(24);
  .row{
        min-height:h(32);
        line-height: h(32);
        /* border:1px solid red; */
        display:flex;
        margin-bottom: h(24);
        
        &:last-child{
            margin-bottom: 0;
        }
        .row-col{
          /* border:1px solid green; */
          min-height: h(32);
          flex:1;
          .i{
            position:absolute;
            display: block;
            width:h(32);
            height: h(32);
            img{
              height:h(32);
              display:block;
              /* border:1px solid #020414; */
              overflow:hidden;
            }
          }
          
          .lable{
            margin-left: w(48);
            display:block;
            font-size:f(26);
            line-height: h(32);
            height: h(32);
            /* border:1px solid red; */
          }
        }
      }
}
/* 版权 */
.banquan{
  /* height:h(108); */
  padding:h(22) w(96);
  background:#020414;
  color:#fff;
  font-size:f(26);
  vertical-align: middle;
  
  /* padding-top: h(20) 0; */
  /* border:1px solid red; */
  .text{
    /* border:1px solid green; */
    width:w(558);
    height:h(32); 
    line-height: h(34);
    text-align:center;
    /* margin:h(20) 0; */
  }


}
</style>





// WEBPACK FOOTER //
// src/App.vue